import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=2588b8eb&scoped=true"
import script from "./Records.vue?vue&type=script&lang=js"
export * from "./Records.vue?vue&type=script&lang=js"
import style0 from "./Records.vue?vue&type=style&index=0&id=2588b8eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2588b8eb",
  null
  
)

export default component.exports